import type { ComponentProps, ReactNode } from "react";
import { cn } from "@/utils";

type DataTableToolbarProps = ComponentProps<"div"> & {
  actions?: ReactNode;
};

/** Dice UI Data Table 的工具栏布局，业务页面负责提供具体筛选项。 */
export function DataTableToolbar({ actions, children, className, ...props }: DataTableToolbarProps) {
  return (
    <div className={cn("flex flex-col gap-2 md:flex-row md:flex-wrap md:items-center", className)} {...props}>
      {children}
      {actions ? <div className="flex shrink-0 items-center justify-end gap-2 md:ml-auto">{actions}</div> : null}
    </div>
  );
}
